module.exports = __webpack_public_path__ + "static/media/icon_yirenzheng.d798af85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_yirenzheng.svg
// module id = 721
// module chunks = 0